// @ts-nocheck converted from existing component
// If making changes look to fix and remove this

import React from "react"
import Notification from "../Notification"
import { useContentJsx } from "@/utils/hooks/useContent"
import { useSelector } from "react-redux"
import { selectMemberDetails } from "@/store/apis/linkApi"

function MobileNumberMissing() {
  const { mobilePhone } = useSelector(selectMemberDetails)
  const { contentBody: content } = useContentJsx(
    `dashboard_notifications.mobile_number_missing`
  )

  if (mobilePhone) {
    return null
  }

  return (
    <Notification notificationType={"info"} closeButton={true}>
      {content}
    </Notification>
  )
}

export default MobileNumberMissing
